import { render, staticRenderFns } from "./booksSet.vue?vue&type=template&id=2b757844&scoped=true"
import script from "./booksSet.vue?vue&type=script&lang=js"
export * from "./booksSet.vue?vue&type=script&lang=js"
import style0 from "./booksSet.vue?vue&type=style&index=0&id=2b757844&prod&lang=less&scoped=true"
import style1 from "./booksSet.vue?vue&type=style&index=1&id=2b757844&prod&lang=less"
import style2 from "./booksSet.vue?vue&type=style&index=2&id=2b757844&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b757844",
  null
  
)

export default component.exports